import React from 'react';

import { IBasicStyledProps, Row } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { PaymentItemSkeleton } from './components';
import { StyledPaymentCol } from './styled';

export const PaymentSkeleton: ReactFCV<IBasicStyledProps> = (rest) => (
  <Row {...rest}>
    <StyledPaymentCol data-testid="payment-col" xs={8} md={7}>
      <PaymentItemSkeleton />
    </StyledPaymentCol>
  </Row>
);
